import { EventListener, isHTMLElementOfType, View, ViewData } from "silver";
import { BookControlViewModeService } from "core/Services/BookControlService";
import { BookControlViewMode } from "core/Controls/Books/BookControl";
import { BooksLang } from "Lang";

const HTML = `<fieldset class="g_resetFieldset g_horizontalMargin">
		<legend class="g_screenReader">{{ lang.LABEL_VIEW }}</legend>
		<div aria-hidden="true" class="form_label">{{ lang.LABEL_VIEW }}</div>
		<div class="flex -row -gutter">
			<input id="view-as-grid" data-myon-on-change="handleListViewRadioChange" type="radio" class="check-input" name="viewAsList" value="0" data-myon-prop-checked="{{ !viewAsList }}">
			<label for="view-as-grid" data-myon-attr-class="flex_item button -withInput -toggle {{ !viewAsList? | '-checked' }} -scrolling">
				<span class="button_scrollContents -text">{{ lang.LABEL_GRID_VIEW }}</span>
				<span class="button_scrollContents">
					<i class="mycon -view_grid"></i>
				</span>
			</label>
			<input id="view-as-list" data-myon-on-change="handleListViewRadioChange" type="radio" class="check-input" name="viewAsList" data-myon-prop-checked="{{ viewAsList }}" value="1">
			<label for="view-as-list" data-myon-attr-class="flex_item button -withInput -toggle {{ viewAsList? | '-checked' }} -scrolling">
				<span class="button_scrollContents -text">{{ lang.LABEL_LIST_VIEW }}</span>
				<span class="button_scrollContents">
					<i class="mycon -view_list"></i>
				</span>
			</label>
		</div>
	</fieldset>`;

interface BookControlViewModeToggleViewData extends ViewData {
	lang: BooksLang;
	viewAsList: boolean;
}

export class BookControlViewModeToggle {

	public readonly onChange = EventListener.create<{ mode: BookControlViewMode, sender?: any }>("change");
	private view: View<BookControlViewModeToggleViewData>;

	constructor(
		lang: BooksLang,
		private bookControlViewModeService: BookControlViewModeService
	) {
		this.view = new View(HTML, {
			handleListViewRadioChange: (e): void => {
				const target = e.target;
				if (!isHTMLElementOfType(target, "input") || !target.checked) {
					return;
				}
				this.setViewMode(
					target.value === "1" ? BookControlViewMode.ROW : BookControlViewMode.CARD,
					this
				);
			}
		}, { lang, viewAsList: this.bookControlViewModeService.preferredViewMode === BookControlViewMode.ROW });
	}

	public get element(): HTMLElement {
		return this.view.element;
	}

	public get viewMode(): BookControlViewMode {
		return this.bookControlViewModeService.preferredViewMode;
	}

	public set viewMode(mode: BookControlViewMode) {
		this.setViewMode(mode);
	}

	private setViewMode(mode: BookControlViewMode, sender?: any): void {
		this.view.dataset.viewAsList = mode === BookControlViewMode.ROW;
		this.bookControlViewModeService.preferredViewMode = mode;
		this.onChange.trigger({ mode, sender });
	}
}
